import * as React from "react"
import { Provider } from "react-redux"
import createStore from "./src/state/createStore"

const wrapRootElement = ({ element }) => {
    // Instantiating store in `wrapRootElement` handler ensures:
    //  - there is fresh store for each SSR page
    //  - it will be called only once in browser, when React mounts
    return <Provider store={ createStore() }>{ element }</Provider>;
}

export default wrapRootElement;
